/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
enum labels {

  eligibility = "Eligibility",
  minimumstay = "MinimumStay",
  travelrestriction = "TravelRestriction",
  salesrestriction = "SalesRestriction",
  childinfantdiscounts = "ChildInfantDiscounts",
  ruleapplication = "RuleApplication",
  ruleid = "RULE ID",
  faretype = "FARE TYPE",
  effdate = "EFF DATE",
  discdate = "DISC DATE",
  ow_rt = "OW/RT",
  foot_note = "FOOTNOTE",
  table_ = "TABLE",
  cat_ = "CAT",
  io_ = "I/O",
  di_ = "DI",
  outbound = "Outbound",
  inbound = "Inbound",
  summary_ = "SUMMARY",
  child = "Child",
  infant = "Infant",
  discounts = "Discounts",
  record = "Record",
  details = "Details",
  other = "Other",
  conditions = "Conditions",
  new_ = "NEW",
  existing_ = "EXISTING",
  rec = "Rec",
  tables = "Tables",
  be = "be",
  added = "added",
  s = "s",
  reccord = "reccord",
  updated = "updated",
  number_ = "NUMBER",
  application_ = "APPLICATION",
  title = "TITLE",
  of_ = "CLASS",
  service = "SERVICE",
  dom = "DOM",
  ntil = "INTL",
  type_ = "TYPE",
  min_ = "MIN",
  max_ = "MAX",
  age_ = "AGE",
  first_ = "FIRST",
  occ_ = "OCC",
  last_ = "LAST",
  status_ = "STATUS",
  account_ = "ACCOUNT",
  code_ = "CODE",
  text_ = "TEXT",
  ok = "Ok",
  name = "Name",
  event = "Event",
  threshold = "THRESHOLD",
  variation = "VARIATION",
  generationDate = "GENERATION DATE",
  oldValues = "OLD VALUES",
  newValues = "NEW VALUES",
  type = "Type",
  class = "CLASS",
  class_ = "Class",
  status = "Status",
  pos = "POS",
  createTrigger = "Create Trigger",
  origin = "Origin",
  destination = "Destination",
  compartment = "Compartment",
  COMP = "COMP",
  depStart = "DEP START",
  depEnd = "DEP END",
  org = "ORG",
  dest = "DEST",
  comp = "COMP",
  pps = "PPS",
  tariff = "Tariff",
  ruleId = "Rule ID",
  fareType = "Fare Type",
  dow = "DOW",
  marketingAirline = "Marketing Airline",
  operatingAirline = "Operating Airline",
  flt1 = "Flt 1",
  flt2 = "Flt 2",
  filterCriteria = "Filter Criteria",
  loc1 = "LOC 1",
  loc2 = "LOC 2",
  fareClassFamily = "Fare Class/Family",
  effDate = "eff Date",
  discDate = "Disc Date",
  owrt = "ow/rt",
  footnote = "Footnote",
  ri = "RI",
  table = "Table",
  cat = "Cat",
  io = "i/o",
  di = "di",
  add = "Add",
  surchargeType = "Surcharge Type",
  chargeInfo = "Charge Information",
  amount1 = "amount 1",
  currency = "Currency",
  feeApplesPer = "fee Applies Per",
  percentage = "Percentage",
  dateNtime = "date and time",
  firstDate = "First Date",
  lastDate = "Last Date",
  abbreviatedText = "Abbreviated Text",
  amount = "Amount",
  equipment = "Equipment",
  record2Details = "Record 2 Details",
  record3Details = "Record 3 Details",
  cxr = "CXR",
  fbc = "FBC",
  rbd = "RBD",
  rtg = "RTG",
  fnt = "FNT",
  ccy = "CCY",
  yq = "YQ",
  yr = "YR",
  tax = "TAX",
  q = "Q",
  travel = "Travel",
  between = "Between",
  from = "from",
  to = "to",
  sale = "Sale",
  blackout = "BLACKOUT",
  season = "SEASON",
  leg = "LEG",
  capacity = "CAPACITY",
  booking = "Booking",
  current = "CURRENT",
  vlyr = "VLYR",
  booked = "BOOKED",
  booked_ = "Booked",
  group = "GROUP",
  components = "COMPONENTS",
  ek = "EK",
  rj = "RJ",
  fz = "FZ",
  gf = "GF",
  g9 = "G9",
  competitor = "COMPETITOR",
  highest = "HIGHEST",
  lowest = "LOWEST",
  ms = "MS",
  fms = "FMS",
  pax = "PAX",
  curr = "CURR",
  prev = "PREV",
  revenue = "Revenue",
  ly = "LY",
  forecast = "FORECAST",
  forecast_ = "Forecast",
  target = "TARGET",
  target_ = "Target",
  vtgt = "VTGT",
  atgt = "ATGT",
  yield = "Yield",
  manualFiledPackage = "Manual Filed Packages",
  totalFiledPackage = "Total Filed Packages",
  systemActionedMarket = "System Actioned Markets",
  totalMarket = "Total Markets",
  activeUsers = "Active Users",
  totalNoOfUsers = "Total no. of Users",
  totalFootnoteCreated = "Total Footnote Created",
  totalFootnoteUpdated = "Total Footnote Updated",
  totalFootnoteDeleted = "Total Footnote Deleted",
  totalFootnoteCleaned = "Total Footnote Cleaned",
  systemReadiness = "System Readiness",
  rawDataStatus = "Raw Data Status",
  competitorAirline = "Competitor Airline",
  in = "In",
  out = "Out",
  jupiter = "Jupiter",
  channel = "Channel",
  taxes = "Taxes",
  effectiveness = "Effectiveness",
  gfs = "GFS",
  rev = "Rev",
  host = "Host",
  sv = "SV",
  ey = "EY",
  tk = "TK",
  wy = "WY",
  me = "ME",
  ku = "KU",
  et = "ET",
  j9 = "J9",
  passeagerTypeMethodType = "Passeager Type And Method Type",
  commissionInformation = "Commission Information",
  ticketingNAirlineRestriction = "Ticketing And Airline Restriction",
  ticketingNAirlineRestriction2 = "Ticketing And Airline Restriction 2",
  ticketingData = "Ticketing Data",
  tableNumbers = "Table Numbers",
  fareBoxData = "Fare Box Data",
  actionSummary = "Action Summary",
  filingDeatails = "Filing Details",
  ticketingSalesPeriod = "Ticketing/Sales Period",
  travelPeriod = "Travel Period",
  ticketedFareBasisCode = "Ticketed Fare Basis Code",
  zonalApproach = "Zonal Approach",
  corporateName = "Corporate Name",
  accountCode = "Account Code",
  ticketDesignator = "Ticket Designator",
  ticketingInstructions = "Ticketing Instructions",
  tourCode = "Tour Code",
  fareRules = "Fare Rules",
  fareAmountBox = "Fare Amount Box",
  validatingAirline = "Validating Airline",
  childInfantDiscount = "Child/Infant Discount",
  oSIField = "OSI Field Entry in PNR",
  disclaimer = "Disclaimer",
  template = "Template",
  remark = "Remark",
  action = "Action",
  fareCreatorTable = "Fare Creator Table",
  securityTable = "Security Table",
  date = "Date",
  time = "Time",
  actionedUser = "ACTIONED USER",
  categoryCahnges = "CATEGORY CHANGES",
  cat1 = "CAT 01",
  cat14 = "CAT 14",
  cat15 = "CAT 15",
  cat25 = "CAT 25",
  cat35 = "CAT 35",
  cat50 = "CAT 50",
  cat25_ = "Cat 25",
  cat35_ = "Cat 35",
  fbr_ = "Fare By Rule",
  templateHistory = "Template History",
  appl = "APPL",
  travelAgency = "TRAVEL AGENCY",
  crxCrs = "CRX/CRS",
  update = "Update",
  redistribute = "REDISTRIBUTE",
  sell = "SELL",
  ticket = "TICKET",
  ticket_ = "Ticket",
  changesOnly = "CHANGES ONLY",
  localesType = "LOCALES TYPE",
  localescode = "LOCALES CODE",
  secSellerControl = " SECONDARY SELLER CONTROL",
  flag = "FLAG",
  count = "Count",
  mainTable = "MAIN TABLE",
  methodType = "METHOD TYPE",
  netGrossInd = "NET/GROSS IND",
  commissionPCT = "COMMISSION PCT",
  commissionAMT = "COMMISSION AMT",
  commissionCURR = "COMMISSION CURR",
  commissionDEC = "COMMISSION DEC",
  ticketingIND = "TICKETING IND",
  ticketingCRX = " TICKETING CRX",
  psgrCoupon = "PSGR COUPON",
  ticketingType = "TICKETING TYPE",
  ticketingTourCode = "TICKETIING TOUR CODE",
  ticketingFareData = "TICKETING FARE DATA",
  oWRT = "OW/RT",
  globalIND = "GLOBAL IND",
  ticketingTAR = "TICKETING TAR",
  remarks = "Remarks",
  f = "F",
  a = "A",
  y = "Y",
  r = "R",
  j = "J",
  c = "C",
  i = "I",
  o = "O",
  m = "M",
  b = "B",
  u = "U",
  k = "K",
  t = "T",
  l = "L",
  x = "X",
  v = "V",
  h = "H",
  e = "E",
  w = "W",
  // eslint-disable-next-line max-len
  info = "The User Needs To Click On Save After Clicking On Clear All Button And Then Select The Parameters And Click Save Again For The Changes To Reflect On The Screen",
  flex = "FLEX^",
  sever = "SEVER",
  allCabin = "ALL_CABIN",
  flexPlus = "FLEX_PLUS",
  economyClass = "ECONOMY CLASS",
  businessClass = "BUSINESS CLASS",
  premiumEconomyClass = "PREMIUM ECONOMY CLASS",
  firstClass = "FIRST CLASS",
  triggerType = "Trigger Type",
  depRange = "DEP RANGE",
  sfLeg1Curr = "SF LEG1 CURR(%)",
  sfLeg1Vlyr = "SF LEG1 VLYR(%)",
  sfLeg2Curr = "SF LEG2 CURR(%)",
  sfLeg2Vlyr = "SF LEG2 VLYR(%)",
  competitorBased = "Competitor Based",
  highVolume = "High Volume",
  lowVolume = "Low Volume",
  highValue = "High Value",
  lowValue = "Low Value",
  eventsPromotions = "Events/Promotions",
  inventoryBased = "Inventory Based",
  others = "Others",
  all = "All",
  accepted = "Accepted",
  rejected = "Rejected",
  dataRange = "Data Range",
  viewed = "Viewed",
  post = "Post",
  pros = "Pros",
  rapid = "Rapid",
  bi = "Bi",
  fromDate = "From Date",
  toDate = "To Date",
  fileDate = "File date",
  jupiterMobile = "Jupiter Mobile",
  tariffName = "TARIFF NAME",
  tariffCode = "TARIFF CODE",
  fareBasis = "Fare Basis",
  seqNo = "SEQ NO",
  tableNo = "Table Number",
  applicatioTitle = "APPLICATION TITLE",
  classOfService = "CLASS OF SERVICE",
  journeyType = "Journey Type",
  domIntl = "DOM/INTL",
  noteText = "NOTE TEXT",
  rulePackageName = "Rule Package Name",
  cat01Eligibility = "Cat01 - Eligibility",
  smartFilingInstructions = "Smart Filing Instructions",
  revenueQualifiersRange = "REVENUE QUALIFIERS RANGE",
  sheetName = "Sheet Name",
  sellUpCode = "Sell Up Code",
  sellUpDescription = "Sell Up Description",
  sellUpName = "Sell Up Name",
  enterAirline = "Enter Airline",
  description = "Description",
  public = "Public",
  private = "Private",
  routing = "Routing",
  ow = "OW",
  rt = "RT",
  seasonality = "Seasonality",
  wipName = "WIP Name",
  filingCurrency = "Filing Currency",
  effective = "Effective",
  priceRange = "Price Range",
  paxType = "Pax Type",
  advPurchase = "Adv Purchase",
  minStay = "Min Stay",
  maxStay = "Max Stay",
  allInFare = "All in Fare",
  surcharge = "Surcharge",
  effectiveOn = "Effective On",
  competitors = "Competitors",
  or = "O/R",
  retFare = "RET Fare",
  currentTotalFare = "Current Total Fare",
  predictedFare = "Predicted Fare",
  recFare = "REC Fare",
  totalRecFare = "Total REC Fare",
  recFrom = "REC From",
  recTo = "REC To",
  salesFrom = "Sales From",
  salesTo = "Sales To",
  tvlFrom = "TVL From",
  tvlTo = "TVL To",
  recoYield = "RECO Yield",
  seasonTag = "Season Tag",
  dateOfWeek = "Date of Week",
  specialFare = "Special Fare",
  baggage = "Baggage",
  sellUp = "Sell Up",
  filingPeriod = "Filing Period",
  outstandingRecord = "Outstanding Record",
  batch = "Batch",
  selectQuarter = "Select Quarter",
  selectMonth = "Select Month",
  selectWeek = "Select Week",
  travelDate = "Travel Date",
  saleDate = "Sale Date",
  tripType = "Trip Type",
  fareRecord = "Fare Record",
  excludeFares = "Exclude Fares",
  packageName = "Package Name",
  rmsPackageDetails = "RMS Package Details",
  save = "Save",
  smartFilingInstruction = "smart filing instruction",
  netChange = "Net Change",
  segNo = "SEG No",
  fareClass = "Fare Class",
  displayType = "Display Type",
  seasonType = "Season Type",
  dayType = "Day Type",
  normalSpecial = "Normal/ Special",
  psgrType = "PSGR Type",
  ticketCode = "Ticket Code",
  minAge = "Min Age",
  maxAge = "Max Age",
  area02areaAddons = "Area 02  Add-Ons",
  area03areaAddons = "Area 03  Add-Ons",
  owToDouble = "OW to Double",
  nuc = "NUC",
  priority = "Priority",
  thresholdTypes = "Threshold Types",
  frequencyDays = "Frequency (Days)",
  triggerTypes = "Trigger Types",
  view = "View",
  reject = "Reject",
  hold = "Hold",
  a1 = "A1",
  a2 = "A2",
  a3 = "A3",
  fb = "FB",
  Exclusion = "Exclusion",
  fare = "Fare",
  odsImpacted = "ODs Impacted",
  marketsImpacted = "Markets Impacted",
  faresImpacted = "Fares Impacted",
  varience = "Varience",
  opportunity = "Opportunity",
  dowType = "Dow Type",
  rtgNo = "RTG No",
  normal = "Normal",
  oo = "OO",
  special = "Special",
  yes = "Yes",
  no = "No",
  not = "Not",
  home = "Home",
  logIn = "Log in",
  signUp = "Sign up",
  myModules = "My Modules",
  contactUs = "Contact Us",
  whatAreYouLookingFor = "What are you looking for?",
  totalFares = "Total Fares",
  totalWp = "Total WP",
  ekDefinition = "EK Definition",
  atpcoDefinition = "ATPCO Definition",
  createdBy = "Created By",
  createdOn = "Created On",
  lastUpdatedBy = "Last Updated By",
  lastUpdatedOn = "Last Updated On",
  search = "Search",
  clear = "Clear",
  locationMappingDetails = "Location Mapping Details",
  locationMapping = "Location Mapping",
  objectives = "Objectives",
  creationDate = "Creation Date",
  id = "ID",
  filingStatus = "Filing Status",
  rulePackageId = "Rule Package ID",
  srNo = "SR No",
  ods = "ODs",
  triggersCount = "Triggers Count",
  posCount = "POS Count",
  od = "OD",
  faresCount = "Fares Count",
  market = "Market",
  triggersRaised = "Triggers Raised",
  allMarkets = "All Markets",
  topMarkets = "Top Markets",
  frequency = "Frequency",
  new = "New",
  newMarkets = "New Market",
  newMarketsTriggers = "New (Market Triggers)",
  newTriggers = "New Triggers",
  percentFareChange = "% Fare Change",
  depaturePeriod = "Depature Period",
  triggerCategory = "Trigger Category",
  positiveNegative = "Positive/Negative",
  variance = "Variance",
  workPackage = "Work Package",
  mostUsed = "Most Used",
  moderatelyUsed = "Moderately Used",
  leastUsed = "Least Used",
  assignedBy = "Assigned By",
  businessArea = "Business Area",
  actionedBy = "Actioned By",
  actionDate = "Action Date",
  filedDate = "Filed Date",
  workUnitName = "Work Unit Name",
  workUnitId = "Work Unit ID",
  checkStatus = "Check Status",
  ruleTariffNo = "Rule Tariff No",
  airlineCode = "Airline Code",
  ruleNo = "Rule No",
  catNo = "Cat No",
  productType = "Product Type",
  creationTime = "Creation Time",
  targetFilingDate = "Target Filing Date",
  actionedDate = "Actioned Date",
  actionedTime = "Actioned Time",
  reviewLabel = "Review Level",
  reason = "Reason",
  instructions = "Instructions",
  bulkBreachedFare = "Bulk/Breached Fare",
  viewBreachedFare = "View Breached Fare",
  kpiAirlineDemandSummary = "KPI - Airline Demand Summary",
  performanceAnalysisAndSuggestion = "Performance Analysis & suggestion",
  kpiHealthCare = "KPI - Healthcare",
  kpiEconomicSitution = "KPI - Economic Situation",
  trigger = "Trigger",
  significantMarket = "Significant market",
  criticalChange = "Critical Triggers",
  marketSummary = "Market Summary",
  workPackageSummary = "Work Package Status",
  ignoredMarkets = "Ignored Markets",
  repetitiveMarket = "Repititve Markets",
  competitorpriceChange = "Competitor Price Change",
  marketWithGrowthOpporunity = "Market with growth opporutity",
  hostEventTrigger = "Host Event Trigger",
  promotionTrigger = "Promotion Trigger",
  usualMarkets = "Usual Markets",
  triggerServerity = "Trigger Serverity Level",
  airlinePricingReimagined = "Airline pricing Re-imagined",
  month = "Month",
  currentYear = "Current Year",
  lastYear = "Last Year",
  capAdj = "CAP ADJ",
  significantMarkets = "Significant Markets",
  averageFare = "Average Fare",
  marketShare = "Market Share",
  triggers = "Triggers",
  totalTriggersByOd = "Total Triggers By OD",
  totalTriggersByType = "Total Triggers By Type",
  totalTriggesByStatus = "Total Triggers By Status",
  forthComingEventsInPricingCalendar = "Forth Coming Events In Pricing Calendar",
  serviceQualityLevel = "Service Quality Level",
  kpiOf = "KPI of",
  nonSigMarkets = "Non SigMarket(s)",
  nonSig = "Non Sig",
  sigMarket = "Sig Market(s)",
  workCompleted = "Work Completed",
  timeTaken = "Time Taken(hr)",
  gdsRevenue = "GDS Revenue",
  ccaRevenue = "CCA Revenue",
  tapRevenue = "TAP Revenue",
  webRebenue = "WEB Revenue",
  selectYear = "Select Year",
  excludeMarket = "Exclude Market",
  selectMultiplePOS = "Select Multiple POS",
  DOWandFlightApplicability = "DOW and Flight Applicability",
  footnotesAvaliable = "Footnotes Avaliable",
  noOfFaresImpacted = "No Of Fares Impacted",
  noOfRulesImpacted = "No Of Rules Impacted",
  dayTime = "Day/Time",
  advancePurchase = "Advance Purchase",
  blackOutDates = "Black Out Dates",
  blackOutDate = "BlackOut Date",
  totalRuleCount = "Total Rule Count",
  fareRecords = "Fare Records",
  newRecord = "New Record",
  increasedRecord = "Increased Record",
  decreasedRecord = "Decreased Record",
  cancelledRecord = "Cancelled Record",
  otherRecord = "Other Record",
  rulesSummary = "Rules summary",
  fareClassApplicationFootnotes = "Fare Class Application Footnotes",
  generalRulesFootnotes = "General Rules Footnotes",
  categoryControlforAllRulesFootnotes = "Category Control for All Rules Footnotes",
  categoryControlforCombinability = "Category Control for Combinability",
  categoryControlForFareByRule = "Category Control for Fare By Rule",
  categoryControlForBlackoutFootnotes = "Category Control for Blackout Footnotes",
  categoryControlForTravelFootnotes = "Category Control for Travel Footnotes",
  categoryControlForSalesFootnotes = "Category Control for Sales Footnotes",
  categoryControlForMiscelleneousFootnotes = "Category Control for Miscelleneous Footnotes",
  minimumStay = "Minimum Stay",
  counts = "Counts",
  noOfDays = "No. of Days",
  maximumStay = "Maximum Stay",
  noOfMonth = "No. of Month",
  amountInQAR = "Amount in QAR",
  totalTriggers = "Total Triggers",
  ODsShortlisted = "OD(s) Shortlisted",
  fareChanges = "Fare Changes",
  actionAnalyzer = "Action Analyzer",
  unusualMoves = "Unusual Moves",
  forthComingEvents = "Forth Coming Events",
  eventPeriod = "Event Period",
  faresDashboard = "Fares Dashboard",
  rulesImpacted = "Rules Impacted",
  outstandingOD = "Outstanding OD",
  qr = "QR",
  ba = "BA",
  mh = "MH",
  dl = "DL",
  addRemarks = "ADD REMARKS",
  withdraw = "Withdraw",
  colse = "CLOSE",
  success = "Success!",
  failed = "Failed",
  gfsNo = "GFSNO",
  fareBrands = "Fare Brands",
  batchId = "Batch Id",
  ComparsionWithPricicngModal = "Comparision with Pricing Modal",
  strategyCode = "Strategy Code",
  marketType = "Market Type",
  strategyType = "Strategy Type",
  strategyElements = "Strategy Elements",
  pricingModalCode = "Pricing Model Code",
  strategyName = "Strategy Name",
  loss = "Loss",
  overRiding = "Over-riding",
  totalAccepted = " Total Accepted",
  totalRejected = "Total Rejected",
  totalStrategies = "Total Strategies",
  overRidingStrategies = "Over-riding Strategies with Pricing Model",
  acceptedStrategies = "Accepted Strategies with Pricing Model",
  rejectedStrategies = " Rejected Strategies with Pricing Model",
  pending = "Pending",
  workPackageQuery = "Work Package Query",
  analyticsSummary = "Analytics Summary",
  workPackageHistory = "Work Package History",
  workPackageWithDraw = "Withdraw WorkPackage",
  fareList = "fareList",
  addOnList = "AddOnList",
  architect = "Architect",
  atpco = "Atpco",
  distinctAirline = "Distinct Airlines",
  nonSignificantMarket = "Non Significant Markets",
  recordSummary = "Records Summary",
  otherChangedRecord = "Other Changed Records",
  newRules = "New Rules",
  changedRules = "Changed Rules",
  location1 = "Location 1",
  location2 = "Location 2",
  value = "Value",
  unit = "unit",
  ruleCount = "Rule Count",
  travelRestriction = "Travel Restriction",
  salesRestriction = "Sales Restriction",
  newFootnote = "New Footnote",
  dateRangeStart = "Date Range Start",
  dateRangeStop = "Date Range Stop",
  commenceDate = "Commence Date",
  expiredDate = "Expired Date",
  latestTicketingDate = "Latest Ticketing Date",
  earliestTicketingDate = "Earliest Ticketing Date",
  category2 = "Category 2",
  category5 = "Category 5",
  category11 = "Category 11",
  timeOfDay = "Time of Day",
  first = "First",
  last = "Last",
  dayRange = "Day/Range",
  dayOfWeek = "Day Of Week",
  thursday = "Th",
  saturday = "Sa",
  sunday = "Su",
  reservationRequried = "Reservation Required Before Departure",
  duration = "Duration",
  ticketingDeparture = "Ticketing Before Departure",
  dateRange = "date/Range",
  date1 = "Date 1",
  date2 = "Date 2",
  significantNonSignificantMarkets = "Significant Non-Significant Markets",
  totalTriggersByOD = "Total Triggers By OD",
  total = "Total",
  tariffRuleIdNFareType = "Tariff,Rule ID and Fare Type",
  airlineInventory = "AirLine Inventory",
  connectingTime = "Connecting Time",
  flightTime = "Flight Time",
  faresAndRules = "Fares And Rules",
  ratings = "Ratings",
  rules = "Rules",
  stopOvers = "Stop Overs",
  advanceReservation = "Advanced Reservation",
  competitorComparsion = "Competitor Comparison",
  addOnFare = "Add-on Fare",
  effFrom = "EFF FROM",
  effTo = "EFF TO",
  blackOutDatesFrom = "BLACKOUT DAYS FROM",
  blackOutDatesTo = "BLACKOUT DAYS TO",
  seasonFrom = "Season From",
  seasonTo = "Season To",
  fbr = "FBR",
  positiveTriggers = "Positive Triggers",
  negativeTriggers = "Negative Triggers",
  oneWay = "One Way",
  roundTrip = "Round Trip",
  mostPopularFare = "Most Popular Fare",
  hostPerformance = "Host Performance",
  recommendation = "Recommendation  ",
  recommendationFareSystem = "Recommended fare by system is ",
  recommendationPeriodFare = "Recommendation period of fare ",
  salesPeriodFare = "Sales period of fare is ",
  currentPassengers = "Current Passengers[PAX] for fare is ",
  recoRange = "Reco Range",
  recoPeriod = "Reco Period",
  recommendationPrice = "Recommendation range of prices is from ",
  cancel = "Cancel",
  recommendationOverreview = "Recommendation Overreview",
  baseFareFlightOfSar = "Base Fare of flight is ",
  additionalFeesOfYq = "Additional Fees of YQ ",
  yrTotalOf = "which makes total of ",
  currentYieldFare = "Current yield of fare is",
  yieldAfterRecommdenation = "Yield after recommendation will be ",
  applicableTravelRestriction = " is applicable for this fare with Travel Restriction from",
  salesRestrictionFrom = " Sales Restriction from",
  seasonalityBlackoouts = "Seasonality, Blackout, Miscellaneous Fare Tags are not applicable.",
  brand = "Brand",
  differential = "Differential",
  modelCode = "Model Code",
  modelName = "Model Name",
  modelDescription = "Model Description",
  mpf = "MPF",
  hff = "HFF",
  lff = "LFF",
  competitorMatch = "Competitor Match",
  oligopoly = "Oligopoly",
  inventory = "Inventory",
  daysToDep = "Days to dep",
  optimalPrice = "Optimal price",
  elasticity = "Elasticity",
  valueVolume = "Value/Volume",
  addField = "Add Field",
  strategical = "Strategical",
  strategyCount = "Strategy Count",
  priceCurve = "Price Curve",
  odHeatMap = "OD Heatmap",
  customerHeatMap = "Customer Heatmap",
  channelHeatMap = "Channel Heatmap",
  priceHistory = "Price History",
  agencies = "Agencies",
  farebrand = "Farebrand",
  customerCharactristics = "Customer Characteristics",
  channelCharactristics = "Channel Characteristics",
  fareAnalysis = "Fare Analysis",
  flightAnalysis = "Flight Analysis",
  competitorSummary = "Competitor Summary",
  competitorRatings = "Competitor Ratings",
  obs = "Obs",
  inc = "Inc",
  totalMarketSelected = " Total Number of Markets Selected",
  totalOd = " Total ODs",
  totalPos = "Total POS",
  compartmentChosen = "Compartments Chosen",
  fareSummary = "Fare Summary",
  totalFareCount = " Total Fares Counts",
  oneWayFare = "One Way Fares",
  returnFares = "Return Fares",
  priceEffectivenessScore = "Price Effectiveness Score",
  pricePerformanceScore = " Price Performance Score",
  priceElasticityScore = "Price Elasticity Score ",
  fairMarketShare = "Fair Market Share",
  triggerHeatMap = "Trigger Heat Map",
  triggerCurve = "Trigger Curve",
  LOGIN = "Login",
  addRemark = "Add Remarks",
  two = "2",
  biDirectional = "Bi-Directional",
  posSettings = "POS Settings",
  exNewYear = "Ex.New Year",
  logicalQuery = "Logical Query",
  marketQueryBuilder = "Market Query Builder",
  airlinePricingImagined = "Airline pricing Re-imagined",
  sendToRulePackage = "Send to Rule Package",
  dashboards = "Dashboards",
  currentRevenue = "CURR REV",
  thousands = "('000)",
  currRevenue = "CURR REV",
  revenueVLYR = "REV VLYR",
  revenueVTGT = "REV VTGT",
  revenueTGT = "REV TGT",
  currentPAX = "CURR PAX",
  paxVLYR = "PAX VLYR",
  paxVTGT = "PAX VTGT",
  hostMS = "HOST MS",
  hostFMS = "HOST FMS",
  a1MS = "A1 MS",
  a1FMS = "A1 FMS",
  a2MS = "A2 MS",
  a2FMS = "A2 FMS",
  a3MS = "A3 MS",
  a3FMS = "A3 FMS",
  msVLYR = "MS(PP)VLYR",
  msVTGT = "MS(pp)VTGT",
  currentYield = "CURR YIELD",
  yieldVLYR = "YIELD VLYR",
  yieldVTGT = "YIELD VTGT",
  currentAverageFare = "CURR AVG FARE",
  averageFareVLYR = "AVG FARE VLYR",
  averageFareVTGT = "AVG FARE VTGT",
  hostMPF = "HOST MPF",
  a1MPF = "A1 MPF",
  a2MPF = "A2 MPF",
  a3MPF = "A3 MPF",
  hostLFF = "HOST LFF",
  a1LFF = "A1 LFF",
  a2LFF = "A2 LFF",
  a3LFF = "A3 LFF",
  dept = "Dept",
  role = "Role",
  culster = "Cluster",
  searchByDashboardOrScreen = "Search By Dashboard or Screen",
  rulePackage = "Rule Package",
  smartfilingInstructions = "Smart Filing Instructions",
  preGFS = "Pre GFS",
  workPackageNumber = "WP Number",
  wpName = "WP Name",
  blackOut = "Blackout",
  username = "Username",
  password = "Password",
  farePerformance = "fare performance",
  return = "Return",
  rbdType = "RBD Type",
  marketPerformance = "Market Performance",
  product = "Product",
  schedule = "Schedule",
  exchange = "Exchange",
  sales = "Sales",
  Fare = "Fare",
  configuration = "Configuration",
  source = "Source",
  transform = "Transform",
  analystics = "Analytics",
  loading = "Loading",
  otherCategories = "Other Categories",
  reviewProcessIsIncomplete = "Review process is incomplete",
  areYouSure = "Are You Sure ?",
  savedSFI = "Smart Filing Instructions Saved! Name: Flynava Technology",
  precheckPoints = "Precheck these points before uploading excel",
  tier = "tier",
  marketReview = "Market Review",
  autoUpload = "Auto Upload",
  autoFiling = "Auto Filing",
  download = "Download",
  accept = "Accept",
  sendBack = "Send Back",
  watch = "Watch",
  reverse = "Reverse",
  manualFiling = "Manual Filing",
  fares = "Fares",
  addOn = "Add-On",
  tableNotFound = "Table Not Found",
  posFrameWorkTemplate = "POS Framework Template",
  saver = "SAVER",
  route = "Route",
  baseFare = "Base Fare",
  newRetentionFare = "New Rentention Fare",
  newTotalFare = "New Total Fare",
  flightNumber = "Flight Number",
  fareStatus = "Fare Status",
  updatedFootNote = "Updated Footnote",
  detailsOf = "Details of ",
  travelTo = "Travel To",
  channelSpread = "Channel Spread",
  distributionSpread = "Distribution Spread",
  customerSpread = "Customer Spread",
  revenueSpread = "Revenue Spread",
  fareSpread = "Fare Spread",
  significant = "Significant",
  nonSignificant = "Non-Significant",
  region = "Region",
  country = "Country",
  totalTriggersByStatus = "Total Triggers By Status",
  events = "Events",
  system = "System",
  manual = "Manual",
  rank = "Rank",
  kpi = "KPI",
  owRt = "ow/rt",
  filedCurrency = "filed currency",
  rev000 = "rev('000)",
  revune000 = "Revenue('000)",
  revVlyr = "rev vlyr",
  paxVlyr = "pax vlyr",
  yieldVlyr = "yield vlyr",
  editGrifParameter = "Edit Grid Parameters",
  premium = "Premium",
  groupedFarePackage = "Grouped Fare Package",
  addonQuery = "Addon Query",
  groupFares = "Group Fares",
  uploadFares = "Upload Fares",
  uploadFaresOffline = "Upload Fares Offline",
  createFarePackage = "Create Fare Package",
  agentCorporate = "Agent/Corporate",
  min = "Min",
  max = "Max",
  fltAppl = "flt Appl ",
  travelFrom = " Travel From",
  manualTrigger = "Manual trigger",
  fileRules = "File Rules",
  defineTheModel = "Define The Model",
  defineTheSellUp = "Define The Sell Up",
  controlCheck = "Control Check",
  marketApplication = "Market Application",
  selected = "Selected",
  week = "Week",
  year = "Year",
  quarter = "Quarter",
  number = "Number",
  of = "Of",
  markets = "Markets",
  chosen = "Chosen",
  compartments = "Compartments",
  sig = "sig",
  finalize = "Finalize",
  filter = "Filter",
  full = "Full",
  screen = "Screen",
  confirmationAlert = "Do you want to save this template?",
  confirmationMessage = "If you click yes, the entered data will be saved for future use",
  triggerReview = "Daily Trigger Review",
  bound = "Bound",
  dep = "Dep",
  flight = "flight",
  stop = "Stop",
  over = "Over",
  filed = "Filed",
  popular = "Popular",
  web = "Web",
  movement = "Movement",
  price = "Price",
  pctWithBracket = "(%)",
  rating = "Rating",
  distributor = "Distributor",
  savedTemplate = "Saved Templates",
  enterSheetName = "Enter Sheet Name",
  copy = "Copy",
  top = "Top",
  bottom = "Bottom",
  booming = "Booming",
  fading = "FADING",
  systemTrigger = "System Trigger",
  actionedTriggers = "Actioned Triggers",
  check = "Check",
  existing = "Existing",
  models = "Models",
  remove = "Remove",
  change = "Change",
  channels = "Channels",
  rbds = "RBD's",
  primary = "Primary",
  economy = "Y",
  business = "J",
  secondary = "Secondary",
  choose = "Choose",
  record2 = "Record 2",
  arrival = "Arrival",
  family = "Family",
  sliceSign = "/",
  summary = "Summary",
  most = "Most",
  rule = "Rule",
  base = "Base",
  on = "On",
  eff = "Eff",
  tvl = "Tvl",
  black = "Black",
  days = "Days",
  adv = "Adv",
  purchase = "Purchase",
  stay = "Stay",
  period = "Period",
  uniqueTariff = "Unique Tariffs ",
  uniqueRuleIds = "Unique Rule Ids ",
  uniqueSequence = "Unique Sequences ",
  totalRecords = "Total Records ",
  NA = "NA",
  record3Table989 = "Record 3 Table 989",
  record3Cat25 = "Record 3 Cat 25",
  baseTable = "BASE TABLE",
  fareCalFind = "FARE IND",
  pct = "PCT",
  filingType = "FILING TYPE",
  categoryOverrideTag = "CATEGORY OVERRIDE TAG",
  one = "01",
  one_ = "1",
  Ztwo = "02",
  three = "03",
  four = "04",
  five = "05",
  six = "06",
  seven = "07",
  eight = "08",
  nine = "09",
  ten = "10",
  eleven = "11",
  twelve = "12",
  thirTeen = "13",
  fourteen = "14",
  fifTeen = "15",
  sixTeen = "16",
  sevenTeen = "17",
  eighTeen = "18",
  nineTeen = "19",
  twenty = "20",
  twentyOne = "21",
  twentyTwo = "22",
  twentyThree = "23",
  twentySix = "26",
  twentySeven = "27",
  twentyEight = "28",
  twentyNine = "29",
  thirtyOne = "31",
  thirtyThree = "33",
  thirtyFive = "35",
  fifty = "50",
  loc1ZoneTable = "LOC 1 ZONE TABLE",
  loc2ZoneTable = "LOC 2 ZONE TABLE",
  fareAppl = "FARE APPL",
  notAppl = "NOT APPL",
  base_Table = "BASE TABLE",
  TDI = "DI",
  SelectFileType = "Please Select File Type",
  back = "back",
  totalTablesToBeAdded = "Total Tables to be added",
  totalRecord2sToBeUpdated = "Total record 2's to be updated",
  excel = "Excel",
  fareByRule = "fareByRule",
  forFCR = "For FCR",
  forFareBrand = "For Fare Brand",
  fareValue = "Fare Value",
  formula = "Formula",
  controlCheckCode = "Control Check Code",
  controlCheckName = "Control Check Name",
  controlCheckDescription = "Control Check Description",
  model = "Model",
  effectiveFrom = "Effective From",
  effectiveTo = "Effective To",
  brief = "Brief",
  edit = "Edit",
  delete = "Delete",
  dates = "Dates",
  datesmall = "Date",
  departure = "Departure",
  proceed = "Proceed",
  passenger = "Passenger",
  method = "Method",
  commission = "Commission",
  information = "Information",
  ticketing = "Ticketing",
  and = "And",
  restriction = "Restriction",
  security = "Security",
  creator = "Creator",
  numbers = "Numbers",
  box = "Box",
  data = "Data",
  psgr = "PSGR",
  net = "Net",
  gross = "Gross",
  percent = "Percent",
  indicator = "Indicator",
  auditor = "Auditor",
  tour = "Tour",
  card = "Card",
  designator = "Designator",
  global = "Global",
  text = "Text",
  upload = "Upload",
  instruction = "Instruction",
  uploaded = "Uploaded",
  by = "By",
  filing = "Filing",
  bookings = "Bookings",
  sf = "Sf",
  vs = "Vs",
  flown = "Flown",
  avaliability = "Availability",
  askm = "Askm",
  var = "Var",
  size = "Size",
  share = "Share",
  capTemplate = "TEMPLATE",
  coverSheet = "COVER SHEET",
  fareSheet = "FARE SHEET",
  viewsecurityTable = "SECURITY TABLE",
  applicaltionTag = "APPLICATION TAG",
  cxrCrsCode = "CXR/CRS CODE",
  dutyFunctionCode = "DUTY/FUNCTION CODE",
  saveTemplate = "Save Template",
  capRemark = "REMARK",
  camName = "Name",
  allFaresAre = "All Fares Are Breached for",
  validate = "validate",
  fail = "fail",
  numberOne = "1",
  numberTwo = "2",
  numberThree = "3",
  numberFour = "4",
  agent = "Agent",
  actioned = "Actioned",
  user = "User",
  posesspecificrules = "Pos es specific rules",
  generalnotes = "General notes",
  record3Table983SecurityTable = "Record 3 Table 983 (Security Table)",
  record3Cat35NegotiatedFare = "Record 3 Cat 35 (Negotiated Fare)",
  record3Cat1 = "Record 3 Cat 1",
  agency = "Agency",
  crs = "Crs",
  changes = "Changes",
  only = "Only",
  locales = "Locales",
  code = "Code",
  sec = "Sec",
  seller = "Seller",
  control = "Control",
  main = "Main",
  ind = "Ind",
  amt = "Amt",
  dec = "Dec",
  coupon = "coupon",
  car = "Car",
  age = "Age",
  occ = "Occ",
  account = "Account",
  next = "Next",
  function = "Function",
  duty = "Duty",
  increased = "Increased",
  newFare = "New Fare",
  decreased = "Decreased",
  cancelled = "Cancelled",
  same = "Same",
  deleted = "Deleted",
  completeBy = "Complete By",
  record3Table983 = "Rec 3 Table 983",
  record3Cat35 = "Rec 3 Cat 35",
  record3Cat01 = "Rect 3 Cat 01",
  inversionCheck = "Inversion Check",
  lowerThreshold = "Lower Threshold",
  upperThreshold = "Upper Threshold",
  floorPrice = "Floor Price",
  lowFare = "Low Fare",
  fareBrand = "Fare Brand",
  templateChanges = "Template Changes",
  templateView = "Template view",
  foll = "foll",
  zero = "0",
  ones = "1",
  current_ = "Current",
  application = "Application",
  tag = "Tag",
  myStatus = "My Status",
  fortNignt = "Fortnight",
  lastDay = "Last Day",
  day = "Day",
  range = "Range",
  Decision = "Decision",
  Analyzer = "Analyzer",
  validationSummary = "Pre GFS Validation Summary",
  content = "content",
  summaryMsg = "Summary of Tariffs and Rule Ids",
  inActive = "Inactive",
  sfi = "SFIs",
  generated = "Generated",
  fbrPreGfs = "FBR",
  tactical = "Tactical",
  active = "Active",
  critical = "Critical",
  norm = "Norm",
  ruleChanges = "Rule Changes",
  wise = "Wise",
  work = "Work",
  package = "Package",
  alignment = "Alignment",
  created = "Created",
  auto = "Auto",
  release = "Release",
  time_ = "Time",
  tracker = "Tracker",
  monday = "Monday",
  tuesday = "Tuesday",
  wednesday = "Wednesday",
  friday = "Friday",
  configured = "Configured",
  calender = "Calender",
  pricing = "Pricing",
  run = "Run",
  exclude = "Exclude",
  recommended = "Recommended",
  select = "Select",
  multiple = "Multiple",
  runtime = "Runtime",
  analytics = "Analytics",
  autopilotRunDetails = "Autopilot Run Details",
  found = "Found",
  sequence = "Sequence",
  write = "Write",
  query = "Query",
  rolling = "Rolling",
  module = "Module",
  rp = "RP",
  cost = "Cost",
  records = "Records",
  perRecord = "Per Record",
  hrs = "Hrs",
  collection = "Collection",
  distinct = "Distinct",
  non = "non",
  update_ = "Update",
  cloning = "Cloning",
  script = "Script",
  management = "Management",
  config = "Config",
  create = "Create",
  competitor_1 = "Competitor",
  poo = "POO",
  ruleId_1 = "(Rule ID)",
  category = "Category",
  createRulePackage = "Create Rule Package",
  modelId = "Model ID",
  startDate = "Start Date",
  endDate = "End Date",
  tarrif = "Tarrif",
  categories = "Categories",
  coded = "Coded",
  copied = "Copied",
  sold = "Sold",
  realized = "Realized",
  trend = "Trend",
  performance = "Performance",
  expectations = "Expectations",
  slash = "/",
  notPermitted = "Not Permitted",
  permitted = "Permitted",
  openBracket = "(",
  closeBracket = ")",
  rangeOrSpecificDays = "(Range or Specific Days)",
  actions = "Actions",
  confirm = "Confirm",
  form = "Form",
  continue = "Continue",
  usage = "Usage",
  unlocked = "Unloacked",
  avg = "Avg",
  actual = "Actual",
  smart = "Smart",
  after = "After",
  before = "Before",
  review = "Review",
  promotions = "Promotions",
  golden = "Golden",
  copper = "Copper",
  zinc = "Zinc",
  flights = "Flights",
  bad = "Bad",
  good = "Good",
  old = "Old",
  pur = "PUR",
  jul = "jul",
  raised = "raised",
  today = "today",
  watched = "watched",
  wpl = "WPL.K1306195-30",
  sixty = "60",
  sixtyDays = "60days",
  cabin = "Cabin",
  reservations = "Reservations",
  must = "must",
  issued = "issued",
  tickets = "tickets",
  triggerLowerThresholdValue = "Trigger Lower threshold value",
  triggerHigherThresholdValue = "Trigger Higher threshold value",
  level = "Level",
  fareUpdate = "Fare Update",
  final = "Final",
  basis = "Basis",
  structure = "STRUCTURE",
  christmas = "Christmas",
  mapping = "Mapping",
  latestSub = "LATEST SUB",
  last4Hours = "LAST 4 HOURS",
  noOfHours = "No. of Hours",
  plus = "Plus",
  financial = "Financial",
  highlights = "Highlights",
  operational = "Operational",
  customer = "Customer",
  satisfaction = "Satisfaction",
  income = "Income",
  compound = "Compound",
  annual = "Annual",
  growth = "Growth",
  rate = "Rate",
  cashflow = "Cashflow",
  inflow = "Inflow",
  outflow = "Outflow",
  fleet = "Fleet",
  expected = "Expected",
  load = "Load",
  factor = "Factor",
  onTime = "On-Time",
  daily = "Daily",
  fleets = "Fleets",
  destinations = "Destinations",
  retention = "Retention",
  promoter = "Promoter",
  score = "Score",
  profile = "Profile",
  passengers = "Passengers",
  industry = "Industry",
  news = "News",
  breakup = "Breakup",
  comparison = "Comparison",
  specified = "SPECIFIED",
  specCalc = "spec/calc",
  fn = "fn",
  tkt = "TKT",
  desg = "desg",
  derived = "derived",
  diff = "diff",
  fcr = "FCR",
  eventName = "Event Name",
  calenderEvent = "Calender Event",
  analyst = "Analyst",
  cluster = "Cluster",
  submit = "SUBMIT",
  calanderEvent = "Calender Event",
  userDefinedEvent = "User Defined Event",
  start = "Start",
  end = "End",
  eventDetails = "Events Details",
  targetOrigin = "Target Origin",
  noOf = "No.Of",
  autoPilotTaskId = "AutoPilot Task Id",
  complaint = "Complaint",
  cancellation = "Cancellation",
  million = "Million",
  composition = "Composition",
  nonTransport = "Non-Transport",
  npm = "NPM",
  expenses = "Expenses",
  profit = "Profit",
  margin = "Margin",
  cash = "Cash",
  operating = "Operating",
  losses = "Losses",
  geographical = "Geographical",
  kilometers = "kilometers",
  available = "Available",
  seats = "Seats",
  seat = "Seat",
  aircraft = "Aircraft",
  utilization = "Utilization",
  fuel = "Fuel",
  efficiency = "Efficiency",
  crew = "Crew",
  productivity = "Productivity",
  mishandling = "Mishandling",
  capacity_ = "Capacity",
  onboard = "Onboard",
  boarding = "Boarding",
  checkIn = "Check-in",
  ratio = "Ratio",
  resolution = "Resolution",
  complaints = "Complaints",
  repeat = "Repeat",
  star = "Star",
  airline = "Airline",
  a4 = "a4",
  metrics = "metrics",
  revenueMetrics = "Revenue metrics",
  percentSymbol = "%",
  yieldMetrics = "Yield Metrics",
  yieldLY = "Yield LY",
  paxMetrics = "Pax Metrics",
  fareMetrics = "Fare Metrics",
  _000 = "('000)",
  exists = "$exists",
  searchPanel = "Search Panel",
  employee = "Employee",
  group_1 = "Group",
  reset = "Reset",
  list = "List",
  addUser = "Add User",
  team = "Team",
  designation = "Designation",
  qualification = "Qualification",
  joining = "Joining",
  birth = "Birth",
  date_1 = "Date",
  of_1 = "of",
  email = "Email",
  Notify = "Notify on Email?",
  Notification = "Notification",
  mobile = "Mobile",
  applicable = "Applicable",
  department = "Department",
  a5 = "a5",
  addEvent = "Add Event",
  defined = "Defined",
  single = "SINGLE",
  open = "OPEN",
  jaw = "JAW",
  double = "DOUBLE",
  oneZero = "10",
  sets = "sets",
  gds = "gds",
  occur = "occur",
  resulting = "Resulting",
  modifier = "Modifier",
  tktg = "tktg",
  accompanied = "Accompanied",
  cmpt = "cmpt",
  accompanting = "Accompanying",
  static = "Static",
  restrictedFrom = "Restricted From",
  restrictedTo = "Restricted To",
  miscellaneous = "Miscellaneous",
  tags = "Tags",
  extensionFare = "Extension Fare",
  prorate = "prorate",
  diffCalc = "Diff Calc",
  seasonalPromotional = "Seasonal/Promotional",
  xSeasonalDPromotional = "X: Seasonal, D: Promotional",
  noOfStopOverOnThePriUnit = "Number Of Stopovers on the Pricing Unit",
  maximumNumberPermitted = "Maximum number permitted",
  unlimited = "Unlimited",
  none = "none",
  noOfStopOverOnTheFareComponent = "Number Of Stopovers on the Fare Component",
  cat_25_Fbr = "Cat-25 Fare By Rule",
  cat_35_Fbr = "Cat-35 Fare By Rule",
  saved = "Saved",
  templateName = "Name:",
  absolute = "Absolute",
  tgt = "TGT",
  date_ = "date",
  noOfTransfersOnThePriUnit = "Number Of Transfer on the Pricing Unit",
  noOfTransfersnTheFareComponent = "Number Of Transfers on the Fare Component",
  chargesApplyOnly = "Charges Apply Only",
  firstAmount = "First Amount",
  singleOpenJaw = "Single Open Jaw",
  ONE_NOT_SIX = "106",
  ONE_NOT_SEVEN = "107",
  ONE_NOT_EIGHT = "108",
  ONE_NOT_NINE = "109",
  lowestAppicableFare = "Lowest Appicable Fare",
  lf = "LF",
  ticketed = "Ticketed",
  p2p = "P2P",
  distance = "Distance",
  connection = "Connection",
  significance = "Significance",
  network = "Network",
  original = "Original",
  trip = "Trip",
  inculsionTable = "Inclusion Table",
  currentBaseFare = "CURRENT BASE FARE",
  updateBaseFare = "UPDATE BASE FARE",
  updateTotalFare = "UPDATE TOTAL FARE",
  recommendationYield = "RECOMMENDATION YIELD",
  fareChangeModel = "Fare Change Model",
  fcst = "FCST",
  effect = "effect",
  manual_ = "Manual",
  summaryOfTariffNRuleIDs = "Summary of tariffs and Rules ID",
  unique = "unique",
  aed = "AED",
  pass = "Pass",
  faill = "Fail",
  packages = "Packages",
  volume = "Volume",
  processing = "Processing",
  access = "Access",
  subModule = "subModule",
  moduleName = "Module Name",
  timeTakenInHrs = "TimeTaken(In Hours)",
  NoDataToDisplay = "No data to display",
  CAT_50_ApplicationsAndOtherConditions = "CAT-50 Application and other Conditions",
  batchUploadedBy = "Batch Uploaded By",
  batchUploadedDate = "Batch Uploaded Date",
  batchUploadedTime = "Batch Uploaded Time",
  NegotiatedFare = "Negotiated Fare",
  editGridParamsInfo =
  // eslint-disable-next-line max-len
  "The User Needs To Click On Save After Clicking On Clear All Button And Then Select The Parameters And Click Save Again For The Changes To Reflect On The Screen.",
  automatedFareRules = "Automated Fare Rules",
  iata = "IATA",
  existingRecord = "Existing Record",
  allCategories = "All Categories",
  include = "Include",
  any = "Any",
  or_ = "Or",
  anyWay = "Anyway",
  securityTableNumber = "Security Table Number",
  fiveNo = "5",
  from_ = "From",
  to_ = "To",
  with = "with",
  add_ = "ADD",
  save_ = "SAVE",
  posSettings_ = "Sig/Non Sig POS",
  logicalQuery_ = "Ex : (( Revenue > 25000) && (Pax <= 1000)) || (( Revenue < 25000 && Revenue > 1000) && !( Yield > 20 ))",
  workPackage_ = "Workpackage",
  example = "ex",
  discount = "Discount",
  oSIFieldEntry = "OSI Field Entry",
  cat01 = "Cat 01",
  cat14_ = "Cat 14",
  cat15_ = "Cat 15",
  cat19 = "Cat 19",
  cat50_ = "Cat 50",
  faster = "faster",
  cheaper = "cheaper",
  and_ = "and",
  layout = "Layout",
  impactedCategory = "IMPACTED CATEGORY",
  preCheckedException = "Prechecked FBR Exceptions",
  totalNumOfParseError = "Total Number of Parse errors found",
  totalNumofTransError = "Total Number of Transform errors found",
  exception = "EXCEPTION",
  errorType = "ERROR TYPE",
  screenName = "SCREEN NAME",
  sheet_Name = "SHEET NAME",
  ofSmall = "of",
  uniqueRules = "Unique Rules",
  reliable = "Reliable",
  least = "Least",
  promo = "Promo",
  sub = "Sub",
  positive = "Positive",
  negative = "Negative",
  fareBasisStructure = "Fare Basis Structure",
  templateName_ = "Template Name:",
  for = "for",
  osiEntryField = "OSI Entry Field",
  notSelected = "Not selected",
  forthComingEventsInPricingCalender = "Forth coming events in pricing calender",
  addOd = "Add OD",
  file = "File",
  error = "Error !",
  duplicateError = "Duplicate SheetName is Not Allowed. Please Rename the Sheet",
  isOrigin = "isOrigin",
  isDestination = "isDestination",
  isTier = "isTier",
  isRevenueQualifiersRange = "isRevenueQualifiersRange",
  totalFare = "Total Fare",
  advPur = "ADV PUR",
  avgFare = "Avg Fare",
  close = "CLOSE",
  securityListTable = "Security Table Number",
  topFiveSigOdsByRev = "Top 5 Sig ODs (by rev)",
  cat14TravelRestriction = "CATEGORY  14 - TRAVEL RESTRICTIONS",
  travelOnOrBefore = "TRAVEL ON OR BEFORE",
  travelOnOrAfter = "TRAVEL ON OR AFTER",
  noDataFound = "No Data Found",
  corporateInstruction = "Corporate Instructions",
  cat15SalesRestrictions = "CATEGORY  15 - SALES RESTRICTIONS",
  saleOnOrBefore = "SALES ON OR BEFORE",
  salesOnOrAfter = "SALES ON OR AFTER",
  cat19ChildrenDiscounts = "CATEGORY  19 - CHILDREN DISCOUNTS",
  childInfant = "CHILD INFANT",
  cat35NegotiatedFares = "CATEGORY  35 - NEGOTIATED FARES",
  slNo = "SI.NO",
  cat50AppAndOtherCond = "CATEGORY  50 - APPLICATION AND OTHER COND",
  sfiCat01Eligibility = "CATEGORY  01 - ELIGIBILITY",
  isFbc = "isFbc",
  isRbd = "isRbd",
  isFareBrand = "isFareBrand",
  uniqueTariff_ = "Unique Tariffs: ",
  uniqueRuleIds_ = "Unique Rule Ids: ",
  uniqueSequence_ = "Unique Sequences: ",
  totalRecords_ = "Total Records: ",
  revenueVtgt = "Revenue VTGT",
  cancleTheFare = "Cancle the fare",
  reco = "Reco",
  dateOfq = "Date of q",
  currentFare = "Current Fare",
  totalCurrent = "Total Current",
  resetAllFare = "Reset all fares",
  totalFareBreakup = "Total Fare Breakup",
  farelevel = "Fare Level",
  tfee = "TFEE",
  bag = "Bag",
  fee = "Fee",
  meal = "Meal",
  seg = "seg",
  visa = "visa",
  flexx = "Flex",
  chooseAnExistingControlCheck = "Choose An Exisiting Control Check",
  charge = "Charge",
  holidayName = "Holiday Name",
  defineModelId = "Define Model Id",
  sellpId = "Sell Up Id",
  controlCheckId = "Control Check Id",
  pricingModelName = "Pricing Model Name",
  pricingModelDesc = "Pricing Model Description",
  effectivePeriod = "Effective Period",
  n = "N",
  yes_ = "YES",
  no_ = "NO",
  selectFareBasis = "Select Fare Basis",
  fareSelected = "Fare(s) selected",
  wouldYouLikeToOtherFarebrandchannel = "Would you like to view other Farebrand/Channel Fares",
  pricingModelCode = "Pricing Model Code",
  document = "Document",
  video = "Video",
  areYouSureToDelete = "Are You Sure To Delete?",
  tariff_ = "Tariffs",
  travelExpireBy = "Travel Expire By",
  salesExpireBy = "Sales Expire By",
  existingTravelStartDate = "Existing Travel Start Date",
  existingTravelEndDate = "Existing Travel End Date",
  newTravelStartDate = "New Travel Start Date",
  newTravelEndDate = "New Travel End Date",
  travelOldTable = "Travel Old Table",
  travelNewTable = "Travel New Table",
  existingSaleStartDate = "Existing Sale Start Date",
  existingSaleEndDate = "Existing Sale End Date",
  newSaleStartDate = "New Sale Start Date",
  newSaleEndDate = "New Sale End Date",
  salesOldTable = "Sales Old Table",
  salesNewTable = "Sales New Table",
  travelSalesQuery = "Travel/Sales Query",
  newTravelFrom = "New Travel From",
  newSalesFrom = "New Sales From",
  newTravelTo = "New Travel To",
  newSalesTo = "New Sales To",
  miscellaneousFareTags = "Miscellaneous Fare Tags",
  salesRestrictions = "Sales Restrictions",
  travelRestrictions = "Travel Restrictions",
  blackouts = "Black Outs",
  noData = "No Data",
  report = "Report",
  youWantToDeleteThisBatchFile = "You want to delete this batch file?",
  usagereport = "usagereport",
  selection = "selection",
  exceptions = "Exceptions",
  specific = "Specific",
  sector = "Sector",
  applicability = "Applicability",
  operated = "Operated",
  approval = "Approval",
  corporates = "Corporates",
  sfis = "SFI's",
  thereIsNoDatatoShow = "There is no data to show",
  moreTriggers = "More Triggers",
  selectairline = "Select Airline",
  fields = "fields",
  sub_fields = "sub-fields",
  relavent = "relavent",
  web_scrape = "web scrape",
  url = "URL",
  suite = "Suite",
  miles = "miles",
  sywards = "sywards",
  upgrade = "upgrade",
  refund = "refund",
  complimentary = "complimentary",
  discounted = "discounted",
  upgrades = "upgrades",
  check_in = "check-in",
  worldwide = "worldwide",
  excess = "excess",
  allowances = "allowances",
  by_piece = "(by piece)",
  paid = "paid",
  lounges = "lounges",
  free = "free",
  wi_if = "wi-if",
  throughout = "throughout",
  your = "your",
  delivery = "delivery",
  relative = "Relative",
  fixed = "Fixed",
  pricingModel = "Pricing Model",
  advancedmodel = "Advanced Model",
  uniqueCode = "Unique Code",
  parameters = "Parameters",
  changeBaseFare = "Change Base Fare",
  updateBy = "Update By",
  excludeType = "Exclude Type",
  thresholdCheck = "Threshold Check",
  workPackageName = "Work Package Name",
  benchmark = "Benchmark",
  thresholdCheckPreview = "Threshold Check Preview",
  addModel = "Add Model",
  addSellUp = "Add Sell Up",
  addControlChecks = "Add Control Checks",
  workPackageID = "Work Package ID",
  serviceType = "Service Type",
  ratingParamter = "Rating Parameter",
  history = "History",
  agility = "Agility",
  reviewOd = "Review OD",
  userRecord = "User Record",
  minutes = "Minutes",
  pp = "pp",
  workpackages = "Workpackages",
  cat25FareByRule = "CATEGORY  25 - FARE BY RULE",
  overRideTag = "Override Tag",
  cat_35 = "CAT-15",
  restrictions = "Restrictions",
  cat_14 = "CAT-14",
  negotiated = "Negotiated",
  cat_19 = "CAT-19",
  childrenInfantDiscount = "Children/Infant Discount",
  appliedFbc = "Applied FBC",
  workflow = "Workflow",
  clearAll = "Clear All",
  tactical_ = "Tactical",
  strategic = "Strategic",
  removeExpired = "Remove Expired",
  assignment = "Assignment",
  tariffCount = "Tariff Count",
  assign = "Assign",
  queryName = "Query Name",
  footnoteLevel = "Footnote Level",
  expiredOn = "Expired On",
  expired = "Expired",
  fareLevel = "Fare Level",
  readAll = "Read All",
  fareFrom = "Fare From",
  fareTo = "Fare To",
  exclusion = "Exclusion",
  biDirection = "Bi-Directional",
  categoryLevel = "Category Level",
  completedBy = "Completed By",
  blackoutDates = "Blackout Dates",
  miscellaneousProvisions = "Miscellaneous Provisions",
  leg1 = "LEG1",
  leg2 = "leg2",
  na = "NA",
  totalRecord2ToBeUpdated = "Total record 2's to be updated",
  rec3Cat50 = "Rec 3 Cat 50",
  inversion = "Inversion",
  geographyRestriction = "Geography Restriction",
  users = "Users",
  tl = "TL",
  posModal = "posModal",
  addOnConstructed = "Add-On Constructed",
  useForProration = " Use For Proration",
  reservationOverride = "Reservation Override",
  onAfter = "On/After",
  onBefore = "On/Before",
  ticketingOverride = "Ticketing Override",
  travelOverride = "Travel Override",
  appliesFor = "Applies For",
  geoTableNumber = "Geo Table Number",
  geographicApplication = "Geographic Application",
  tsi = "TSI",
  ticketsMustBeIssued = "Tickets Must Be Issued",
  reservationMustBe = "Reservation Must Be",
  override = "Override",
  psgrFirstOcc = " PSGR First Occ",
  psgrLastOcc = " PSGR Last Occ",
  psgrStatus = "PSGR Status",
  psgrRestrictions = "PSGR Restrictions",
  loc = "Loc",
  mustNotBe = "Must Not Be",
  partnerMapping = "Partner Mapping",
  partner = "Partner",
  hostFootnote = "Host Footnote",
  areYouToDelete = "Are you sure you want to delete?",
  partnerList = "Partner List",
  competitorList = "Competitor List",
  superTactical = "Super Tactical",
  masterStrategy = "Master Strategy",
  destinationRegion = "Destination Region",
  originRegion = "Origin Region",
  tableNoNotGeneratedMsg = "Atleast one table number should be generated",
  tariffsSelected = "Tariff selected",
  catCoded = "CAT Coded",
  fareCountAttached = "Fare count attached",
  tableNumber = "Table Number",
  textTableNumber = "Text Table Number",
  overrideTableNo = "Override Table Number",
  generateTableNumbers = "Generate Table Numbers",
  pleaseSelectFirstLastDate = "Please select First and Last date",
  pleaseSelectAfterBeforeSeasonal = "Please select On/After or On/Before and Seasonal/Promotional",
  PleaseSelectReturnTravel = "Please select Return travel date and time",
  pleaseSelectCommenceDates = "Please select Commence date",
  PleaseSelectResMustOrTktMust = "Please select Reservation must be or Ticket must be",
  pleaseSelectAddonsOrProRate = "Please select Addons or Use of proration",
  returnTravel = "Return Travel",
  returnBy = "Return By",
  ticketMustBeIssued = "Ticket Must Be Issued",
  useofProration = "Use of proration",
  labelGroupId = "Label Group ID",
  selectAll = "Select All",
  commence = "commence",
  noOfFares = "No Of Fares",
  blankM = "Blank M",
  blankN = "Blank N",
  blankO = "Blank O",
  blankP = "Blank P",
  updateFares = "Update Fares",
  shouldBeBetween = "Should be between",
  countryCode = "Country Code",
  typeOfFare = "Type Of Fare",
  cat04 = "Cat 04",
  cat16 = "Cat 16",
  cat10 = "Cat 10",
  cat18 = "Cat 18",
  penalties = "Penalties",
  ticketEndorsement = "Ticket Endorsement",
  flightApplication = "Flight Application",
  combination = "Combination",
  charges = "Charges",
  waiver = "Waiver",
  vol = "Vol",
  inVol = "invol",
  ref = "Ref",
  canx = "Canx",
  chrg = "Chrg",
  rep = "Rep",
  chgn = "Chgn",
  pta = "Pta",
  portion = "Portion",
  amt1 = "Amt1",
  amt2 = "Amt2",
  cur1 = "Cur1",
  cur2 = "Cur2",
  hl = "H/L",
  death = "Death",
  illness = "Illness",
  scho = "Scho",
  chge = "Chge",
  nineNineSix = "996",
  general = "General",
  sequences = "Sequences",
  characters = "Characters",
  fareFromCompareMsg = "Fare from must be smaller than fare to",
  fareToCompareMsg = "Fare to must be smaller than fare from",
  workFlowQuery = " Workflow Query",
  fareCount = "Fare Count",
  ruleSeqCount = "Rule Seq Count",
  airlineType = "Airline Type",
  totalAirline = "Total Airlines",
  totaltariff = "Total Tariffs",
  totalFootnote = "Total Footnotes",
  activeFares = "Active Fares",
  inActiveFares = "Inactive Fares",
  expiredFares = "Expired Fares",
  appliedFootnote = "Applied Footnote",
  parameter = "Parameter",
  unit_1 = "Unit",
  numberFive = "5",
  lastRun = "Last Run",
  latestRun = "Latest Run",
  fnAvailable = "FN Available",
  fnNotAvailable = "FN not Available",
  fnAttached = "FN Attached",
  fnNotAttached = "FN not Attached",
  eventStatus = "Event Status",
  footnoteStatus = "Footnote Status",
  footnoteAlignment = "Footnote Alignment",
  used = "Used",
  forward = "Forward",
  city = "City",
  cat06 = "Cat 06",
  cat07 = "Cat 07",
  flight_ = "Flight",
  fltNo1 = "Flt No.1",
  cxr1 = "CXR 1",
  rel = "REL",
  fltNo2 = "Flt No.2",
  cxr2 = "CXR 2",
  cxr3 = "CXR 3",
  cxr_tbl_no = "Cxr Tbl No",
  fltNo3 = "Flt No.3",
  travelAppl = "Travel Appl",
  travelLoc = "Travel LOC",
  travelBet = "Travel Bet",
  travelAnd = "Travel And",
  travelViaIndia = "Travel Via India",
  travelViaGeo = "Travel Via Geo",
  hidden = "Hidden",
  eqp = "EQP",
  filler = "Filler",
  dateTblNo = "Date Tbl No",
  textTblNo = "Text Tbl No",
  fareFamily = "Fare Family",
  fareBasisCode = "Fare Basis Code",
  footnoteTrigger = "Footnote Trigger",
  voluntaryChanges = "Voluntary Changes",
  cat31 = "Cat 31",
  voluntaryRefund = "Voluntary Refund",
  cat33 = "Cat 33",
  alert = "Alert",
  warning = "Waring",
  ancillaryRange = "Ancillary Range",
  liteFare = "Lite Fare",
  delta = "Delta",
  logic = "Logic",
  fareBrandDetails = "Fare Brand Details",
  recommendedFareRange = "Recommended Fare Range",
  ancillary = "Ancillary",
  allocated = "Allocated",
  footnoteOptimizer = "Footnote Optimizer",
  expiredFootnotes = "Expired Footnotes",
  previous = "Previous",
  fareswithExpiredFootnotes = "Fares with Expired Footnotes",
  ruleswithExpiredFootnotes = "Rules with Expired Footnotes",
  outputCsv = "output.csv",
  seasonalityFrom = "Seasonality From",
  extensionsFare = "Extensions Fare",
  proRate = "Prorate",
  startDate_ = "Start Date",
  seasonalityTo = "Seasonality To",
  both = "Both",
  combinability = "Combinability",
  userManagement = "User Management",
  systemGeneratedRuleId = "System generated Rule ID",
  userInputRuleId = "User Input Rule ID",
  userAction = "User Action",
  traveling = "Traveling",
  at = "At",
  maximum = "Maximum",
  the = "The",
  pes = "Pes",
  cur = "Cur",
  applies = "Applies",
  reissue = "Reissue",
  revalidation = "Revalidation",
  show = "Show",
  via = "Via",
  hip = "Hip",
  connections = "Connections",
  stopOvers_ = "Stopovers",
  endorsement = "endorsement",
  location = "Location",
  calculation = "Calculation",
  construction = "Construction",
  prorations = "Prorations",
  extention = "Extention",
  off = "Off",
  peak = "Peak",
  round = "Round",
  world = "World",
  turn = "Turn",
  around = "Around",
  governs = "Governs",
  business_ = "Business",
  economy_ = "Economy",
  addMoreBlackoutDates = "Add more blackout dates",
  footNotePackageName = "Footnote Package Name",
  footNotePackageId = "Footnote Package ID",
  operation = "Operation",
  footnoteImpacted = "Footnote Impacted",
  userAuto = "User/Auto",
  creationDateTime = "Creation Date & Time",
  filedDateAndTime = "Filed Date & Time",
  filedStatus = "Filed Status",
  selectPackage = "Select package",
  footnotepackage = "Footnote package",
  rulepackage = "Rule package",
  manager = "Manager",
  record2Of = "Record 2 of",
  impactModel = "Impact Model",
  daysToDepature = "Days to Departure",
  distributorRating = "Distributor Rating",
  faresRating = "Fares Rating",
  marketRating = "Market Rating",
  airlineRating = "Airline Rating",
  capacitySchedule = "Capacity Schedule",
  digitalFootprint = "Digital Footprint",
  productRating = "Product Rating",
  absolutePercentage = "Absolute/ Percentage",
  chooseAnExistingImpact = "Choose An Existing Impact",
  alertInstruction = "Click on the package to view and release that before filing a new one or click above to proceed with filing anyway",
  alertMessage = " are currently available for release from the packages screens. It is strongly advised to address these IDs before proceeding with the filing of the new rule package.",
  detected = "detected",
  identifiedWithRuleID = " identified with rule ID",
  threePackages = "Three packages",
  twoPackages = "Two packages",
  linkedTo = "Linked To",
  addNewFare = "Add New Fare",
  allFbcFares = "All FBC Fares",
  deleteTheFare = "Delete the Fare",
  sellupFares = "Sellup Fares",
  cancelTheFare = "Cancel the fare",
  ta = "ta",
  factors = "Factors",
  impact = "Impact",
  back_ = "Back",
  LFF = "LFF",
  HFF = "HFF",
  grant = "Grant",
  assigning = "Assigning",
  given = "Given",
  recieved = "Recieved",
  circle = "Circle",
  dayTime_ = "Day Time",
  stopOver_ = "Stopover",
  transfer = "Transfer",
  impactModelId = "Impact Model Id",
  packageId = "Package ID",
  downloadedBy = "Downloaded By",
  downloadedDate = "Downloaded Date",
  downloadedTime = "Downloaded Time",
  revenueManagement = "Revenue Management",
  revenueAccounting = "Revenue Accounting",
  commercialWarehouse = "Commercial Warehouse",
  fareCounts = "fareCounts",
  Pseudo_od = "Pseudo OD",
  triggerClass = "Trigger Class",
  oldDoc = "Old Doc",
  newDoc = "New Doc",
  request = "Request",
  is = "Is",
  made = "Made",
  apply = "Apply",
  residual = "Residual",
  within = "Within",
  validity = "Validity",
  rec3Table996 = "Record - 03 Table 996",
  condition = "Condition",
  componant = "Componant",
  per = "Per",

  totalPax = "Total Pax",
  dyPax = "Dy pax",
  avgDyPax = "Average DY pax",
  entryViaApp = "Entry via APP",
  entryViaKIOSK = "entry via KIOSK",
  Airport = "Airport",
  Year = "Year",
  ytd = "Ytd",
}

export default labels;

export const rulesArray: string[] = [
  "Template should be in XLSX format.",
  "Hidden columns should be blank.",
  "Strike-through/Colored Cells or Text is out of scope.",
  "Negation City/countries found beside Destination should receive in rules sheet separately.",
  "Destination not as per IATA definition. ex.SASC,SWP,ALL,UAE,GCC,UK,GMEI,ANZ,IO.",
  "O/D/ Location should be either City or Country not both i.e. GB or LON not like GB-LON.",
  "Other rules categories to be updated in rows format only (not Tabular format).",
  "The discount column shouldn't be merged.",
  "Appropriate date format to be used.",
];

export const passwordInstructions: string[] = [
  "Be at least 8 characters long",
  "Not be easily guessable or related to personal information (e.g., avoid using your name, username, or birthdate)",
  "Contain a mix of uppercase and lowercase letters, numbers, and special characters",
];
